// extracted by mini-css-extract-plugin
export const navBar = "navBar-module--navBar--2hlR6";
export const trameLight = "navBar-module--trameLight--2PnGX";
export const white = "navBar-module--white--3Dl8z";
export const black = "navBar-module--black--1dD4h";